import React from "react";
import Navbar from "../../components/navbar/Navbar";
import { Box } from "@mui/material";
import Footer from "../../components/Footer/Footer";
import Collab from "../../components/collab/collab";

const collab = () => {
	return (
		<Box>
	    <Navbar />
        <Collab />
		<Footer />
		</Box>
	);
};

export default collab;